/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 * Migrated from: lego/constants/etmf.js
 */

export const MasterDataType = {
  PRODUCT: 'PRODUCT',
  ENVIRONMENT: 'ENVIRONMENT',
  TRIAL: 'TRIAL',
  STUDY: 'STUDY',
  COUNTRY: 'COUNTRY',
  SITE: 'SITE'
} as const

export type MasterDataTypeValue = (typeof MasterDataType)[keyof typeof MasterDataType]

export const EtmfListView = {
  ...MasterDataType,
  FILE_PLAN: 'FILE_PLAN',
  PACKAGE: 'PACKAGE'
} as const

export const EtmfLevel = {
  ALL: 'ALL',
  STUDY: 'STUDY',
  COUNTRY: 'COUNTRY',
  SITE: 'SITE'
} as const

export type EtmfLevelType = (typeof EtmfLevel)[keyof typeof EtmfLevel]

export type EtmfListViewType = (typeof EtmfListView)[keyof typeof EtmfListView]

export const AllLevel = {
  ALL: 'ALL',
  PRODUCT: 'PRODUCT',
  STUDY: 'STUDY',
  COUNTRY: 'COUNTRY',
  SITE: 'SITE'
} as const

export type AllLevelType = (typeof AllLevel)[keyof typeof AllLevel]

export const DocCompletionStatus = {
  ALL: 'ALL',
  NOT_STARTED: 'NOT_STARTED',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED'
} as const

export type DocCompletionStatusType = (typeof DocCompletionStatus)[keyof typeof DocCompletionStatus]

export const DocCompletionStatusReverse = {
  COMPLETED: 'COMPLETED',
  IN_PROGRESS: 'IN_PROGRESS',
  NOT_STARTED: 'NOT_STARTED',
  ALL: 'ALL'
} as const

export type DocCompletionStatusReverseType =
  (typeof DocCompletionStatusReverse)[keyof typeof DocCompletionStatusReverse]
export type EtmfListViewValue = (typeof EtmfListView)[keyof typeof EtmfListView]
export type EtmfLevelValue = (typeof EtmfLevel)[keyof typeof EtmfLevel]
export type AllLevelValue = (typeof AllLevel)[keyof typeof AllLevel]
